import { Map } from "immutable"

import {
    CLUSTER_LIST_REQUEST as LIST_REQUEST,
    CLUSTER_LIST_RESPONSE as LIST_RESPONSE,
    CLUSTER_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    CLUSTER_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    CLUSTER_ITEM_DELETE_RESPONSE as ITEM_DELETE_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    title: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_DELETE_RESPONSE
    },
    defaultSearchCriteria
)
